import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'lc-skip-to-content, [lcSkipToContent]',
  imports: [CommonModule, RouterLink],
  templateUrl: './lc-skip-to-content.html',
  host: { class: 'skip-to-content' },
})
export class lcSkipToContent {
  @Input() mainContentID = 'main-content';
  @Input() mainContentButtonLabel = 'Skip to main content';
  @Input() secondContentID? = '';
  @Input() secondContentButtonLabel? = '';
  @Input() thirdContentID? = '';
  @Input() thirdContentButtonLabel? = '';
}
